import {
  CostLineContainer,
  CostLineFooter,
  CostLineHeader,
  CostLinesAccordion,
  useCostLinesStore,
} from "entities/CostLines";
import { useRequestStore } from "entities/Request";
import {
  TravelLinesAccordion,
  useRequestLinesStore,
} from "entities/TravelLines";
import {
  EditPrivateTime,
  EditTravelLine,
  TravelLineControlsHeader,
} from "features/EditRequestLines";
import { memo } from "react";

// TODO decomposition according to fsd
import { RequestAccessController } from "entities/Request/utils/RequestAccessController";
import { useTranslation } from "react-i18next";
import { ROLES } from "shared/config";

const access = new RequestAccessController();

function RequestLinesContainer({
  costLinesRefs = [],
  travelLinesRefs = [],
  handleRequestLineDelete,
  userRole,
}) {
  const { t } = useTranslation(["CostLine", "TravelLine", "CostGroup"]);
  const request = useRequestStore((state) => state.request);
  const costLines = useCostLinesStore((state) => state.costLines);
  const travelLines = useRequestLinesStore((state) => state.travelLines);
  const travelPlanSchema = useRequestLinesStore(
    (state) => state.travelPlanSchema
  );

  return (
    <div className="mb-3 mb-md-5">
      {userRole !== ROLES.COST_GROUP && travelLines?.length > 0 && (
        <TravelLinesAccordion
          defaultAllOpen={userRole === ROLES.ACCOUNTS_PAYABLE}
          userRole={userRole}
        >
          {travelLines.map((travelLineData, idx) => {
            if (travelLineData.interval_type_id?.label === "Private time")
              return (
                <EditPrivateTime
                  key={travelLineData.id}
                  ref={travelLinesRefs[idx]}
                  // @ts-ignore
                  userRole={userRole}
                  traveLineId={travelLineData.id}
                  traveLineIndex={idx}
                  travelLineData={travelLineData}
                  disabled={access.to("TravelLine", "edit").unprovided()}
                  // ? accordionHeader is handled by TravelLinesAccordion
                  accordionHeader={
                    <TravelLineControlsHeader
                      disabled={access.to("TravelLine", "edit").unprovided()}
                      headerText={t("private_time", { ns: "TravelLine" })}
                      isFirstLine={idx === 0}
                      isLastLine={idx === travelLines.length - 1}
                      travelLineIdx={idx}
                      handleTravelLineDelete={handleRequestLineDelete}
                      travelLineId={travelLineData.id}
                    />
                  }
                />
              );
            else
              return (
                <EditTravelLine
                  key={travelLineData.id}
                  ref={travelLinesRefs[idx]}
                  // @ts-ignore
                  userRole={userRole}
                  requestId={request.id}
                  traveLineId={travelLineData.id}
                  traveLineIndex={idx}
                  travelLineData={travelLineData}
                  disabled={access.to("TravelLine", "edit").unprovided()}
                  isLastLine={
                    idx === travelLines.length - 1 && travelLines.length > 1
                  }
                  // ? accordionHeader is handled by TravelLinesAccordion
                  accordionHeader={
                    <TravelLineControlsHeader
                      disabled={access.to("TravelLine", "edit").unprovided()}
                      isFirstLine={idx === 0}
                      isLastLine={idx === travelLines.length - 1}
                      handleTravelLineDelete={handleRequestLineDelete}
                      travelLineIdx={idx}
                      headerText={`${
                        travelPlanSchema[idx]?.startPlace?.label
                          ? travelPlanSchema[idx]?.startPlace?.label.split(
                              ","
                            )[0]
                          : ""
                      } - ${
                        travelPlanSchema[idx]?.endPlace?.label
                          ? travelPlanSchema[idx]?.endPlace?.label.split(",")[0]
                          : ""
                      }`}
                      travelLineId={travelLineData.id}
                    />
                  }
                />
              );
          })}
        </TravelLinesAccordion>
      )}
      {costLines.length > 0 && (
        <CostLinesAccordion defaultAllOpen userRole={userRole}>
          {costLines.map((costLine, idx) => (
            <CostLineContainer
              key={costLine.id}
              // @ts-ignore
              // accordionHeader prop is used by CostLinesAccordion component
              accordionHeader={
                <CostLineHeader
                  userRole={userRole}
                  costLine={costLine}
                  canDelete={access
                    .to("CostLine", "delete")
                    .withCostLineValidation(costLine.id)
                    .provided()}
                />
              }
              access={access}
              costLineData={costLine}
              request={request}
              ref={costLinesRefs[idx]}
              idx={idx}
              disabled={access
                .to("CostLine", "edit")
                .withCostLineValidation(costLine.id)
                .withLock()
                .withHold()
                .unprovided()}
              footer={
                <CostLineFooter
                  idx={idx}
                  access={access}
                  userRole={userRole}
                  costLine={costLine}
                  costLinesRefs={costLinesRefs}
                />
              }
            />
          ))}
        </CostLinesAccordion>
      )}
    </div>
  );
}

export default memo(RequestLinesContainer);
